"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const Colors_1 = __importDefault(require("../../../assets/colors/Colors"));
const BackHeader_1 = __importDefault(require("../../../assets/icons/BackHeader"));
const components_1 = require("../../../components");
const CustomText_1 = __importDefault(require("../../../components/text/CustomText"));
const Routes_1 = __importDefault(require("../../../navigators/Routes"));
const scale_1 = require("../../../utils/scale");
const styles_1 = __importDefault(require("./styles"));
const DeleteAccountScreen = (props) => {
    return (react_1.default.createElement(react_native_1.View, { style: {
            flex: 1,
            backgroundColor: '#F7F7F7',
            justifyContent: 'space-between',
        } },
        react_1.default.createElement(react_native_1.View, null,
            react_1.default.createElement(components_1.Header, { statusBarStyle: "dark-content", styleViewCenter: { alignItems: 'center' }, titleStyle: {
                    alignSelf: 'center',
                    paddingRight: (0, scale_1.scale)(20),
                }, title: 'アカウント', styleContainer: {
                    backgroundColor: Colors_1.default.white,
                }, leftIcon: react_1.default.createElement(BackHeader_1.default, null) }),
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.main },
                react_1.default.createElement(react_native_1.View, { style: { flexDirection: 'row' } },
                    react_1.default.createElement(react_native_1.View, { style: styles_1.default.Rectangle }),
                    react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                            fontSize: (0, scale_1.moderateScale)(16),
                            lineHeight: (0, scale_1.moderateScale)(24),
                            color: '#292A33',
                            fontWeight: '300',
                            paddingLeft: (0, scale_1.scale)(8),
                        } }, "\u4F1A\u54E1\u60C5\u5831")),
                react_1.default.createElement(CustomText_1.default, { weight: "600", style: {
                        fontSize: (0, scale_1.moderateScale)(14),
                        lineHeight: (0, scale_1.moderateScale)(21),
                        color: '#545454',
                        paddingTop: (0, scale_1.scale)(8),
                    } }, "\u4F1A\u54E1\u60C5\u5831"),
                react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                        fontSize: (0, scale_1.moderateScale)(15),
                        lineHeight: (0, scale_1.moderateScale)(23),
                        color: '#292A33',
                        paddingTop: (0, scale_1.scale)(8),
                    } }, "\u7121\u6599\u4F1A\u54E1"),
                react_1.default.createElement(react_native_1.TouchableOpacity, { style: { alignSelf: 'center', marginTop: (0, scale_1.scale)(24) }, onPress: () => {
                        props.navigation.navigate(Routes_1.default.DELETE_ACCOUNT_ONE_SCREEN);
                    } },
                    react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                            fontSize: (0, scale_1.moderateScale)(14),
                            lineHeight: (0, scale_1.moderateScale)(21),
                            color: '#888888',
                            textAlign: 'center',
                        } }, "\u30A2\u30AB\u30A6\u30F3\u30C8\u524A\u9664"))))));
};
exports.default = DeleteAccountScreen;
